import DepartmentModel from '@/models/department/Department.model';

export default class Departments {
  constructor(regions = {}, cities = [], places = {}) {
    this.regions = Object.entries(regions)
      .map(([label, value]) => new DepartmentModel({ label, value }));
    this.cities = cities
      .map(({ name: label, uid: value }) => new DepartmentModel({ label, value }));
    this.places = Object.entries(places)
      .map(([value, label]) => new DepartmentModel({ label, value }));
  }

  getRegions() {
    return this.regions;
  }

  getCities() {
    return this.cities;
  }

  getPlaces() {
    return this.places;
  }
}
